import clsx from 'clsx'
import React, {FC} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../_metronic/partials'
import {useAuth} from '../../modules/auth'
import {Link} from 'react-router-dom'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  const {currentUser} = useAuth()

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* begin::Theme mode */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <ThemeModeSwitcher
          toggleBtnClass={clsx('btn-active-light-primary btn-custom', toolbarButtonHeightClass)}
        />
      </div>
      {/* end::Theme mode */}

      {/* begin::User */}
      {currentUser ? (
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <KTSVG
              path='/media/icons/duotune/communication/com006.svg'
              className='svg-icon-muted svg-icon-3hx'
            />
          </div>
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
      ) : (
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}>
            <Link to='/auth' className='btn btn-sm fw-bold btn-primary'>
              Sign In
            </Link>
          </div>
        </div>
      )}
      {/* end::User */}
    </div>
  )
}

export {Topbar}
